import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'unicodeToEmoji',
})
export class UnicodeToEmojiPipe implements PipeTransform {
    transform(unicode: string): string {
        if (!unicode) return '';
        try {
            return String.fromCodePoint(parseInt(unicode, 16));
        }
        catch (e) {
            return '';
        }
    }
}